import axios from 'axios';

const BASE_URL = process.env.REACT_APP_SURVIVOR_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default {
  get: async (endpoint) => {
    try {
      const response = await api.get(endpoint);
      return response.data;
    } catch (error) {
      console.error('GET error:', error);
      throw error;
    }
  },
};
